@if (this.carDetail$ | async; as carDetail) {
  <div
    class="tab-pane fade flex-even active show"
    id="sales"
    role="tabpanel"
    aria-labelledby="sales-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="form-group-title my-1" translate>LEAD_FIELDSET_DRIVER</div>
      <div class="row mt-2">
        <div class="col-12 col-xl-6">
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >LEAD_LBL_DRIVER_GENDER</label
              >
              <div class="col-auto">
                <span class="form-control-plaintext form-control-sm">
                  {{ carDetail.driverGender }}
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
                >LEAD_LBL_DRIVER_LASTNAME</label
                >
                <div class="col-auto">
                  <span class="form-control-plaintext form-control-sm">
                    {{ carDetail.driverLastName }}
                  </span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >LEAD_LBL_DRIVER_FIRSTNAME</label
                  >
                  <div class="col-auto">
                    <span class="form-control-plaintext form-control-sm">
                      {{ carDetail.driverFirstName }}
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-form-label-sm" translate
                    >LEAD_LBL_DRIVER_MARITAL_STATUS</label
                    >
                    <div class="col-auto">
                      <span class="form-control-plaintext form-control-sm">
                        {{ carDetail.driverMaritalStatus }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="form-group row">
                    <label class="col-4 col-form-label-sm" translate
                      >LEAD_LBL_DRIVER_ADDRESS</label
                      >
                      <div class="col">
                        <div class="form-control-plaintext form-control-sm mb-2 h-100 p-0">
                          <app-address
                            [address]="carDetail.driverAddress"
                            [zipCode]="carDetail.driverZipCode"
                            [city]="carDetail.driverCity"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >LEAD_LBL_DRIVER_BIRTHDATE</label
                          >
                          <div class="col-auto">
                            <span class="form-control-plaintext form-control-sm">
                              {{ carDetail.driverBirthdate | date : "dd/MM/yyyy" }}
                            </span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate
                            >LEAD_LBL_DRIVER_LICENSE_DATE</label
                            >
                            <div class="col-auto">
                              <span class="form-control-plaintext form-control-sm">
                                {{ carDetail.licenseDate | date : "dd/MM/yyyy" }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group-title my-1" translate>
                        LEAD_FIELDSET_INSURANCE_HISTORY
                      </div>
                      <div class="row mt-2">
                        <div class="col-12 col-xl-6">
                          <div class="form-group row">
                            <label class="col-4 col-form-label-sm" translate
                              >LEAD_LBL_DRIVER_YEARS_INSURED</label
                              >
                              <div class="col-auto">
                                <span class="form-control-plaintext form-control-sm">
                                  {{ carDetail.yearsInsured }}
                                </span>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-4 col-form-label-sm" translate
                                >LEAD_LBL_DRIVER_BONUS_MALUS</label
                                >
                                <div class="col-auto">
                                  <span class="form-control-plaintext form-control-sm">
                                    {{ carDetail.bonusMalusLoc }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-xl-6">
                              <div class="form-group row">
                                <label class="col-4 col-form-label-sm" translate
                                  >LEAD_LBL_DRIVER_MONTH_INSURANCE_INTERRUPTION</label
                                  >
                                  <div class="col-auto">
                                    <span class="form-control-plaintext form-control-sm">
                                      {{ carDetail.monthInsuranceInterruptionLoc }}
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label class="col-4 col-form-label-sm" translate
                                    >LEAD_LBL_DRIVER_INSURANCE_TERMINATION</label
                                    >
                                    <div class="col-auto">
                                      <span class="form-control-plaintext form-control-sm">
                                        {{ carDetail.insuranceTerminationLoc }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="form-group-title my-1" translate>
                                LEAD_FIELDSET_LICENSE_HISTORY
                              </div>
                              <div class="row mt-2">
                                <div class="col-12 col-xl-6">
                                  <div class="form-group row">
                                    <label class="col-4 col-form-label-sm" translate
                                      >LEAD_LBL_DRIVER_LICENSE_ANNULATION</label
                                      >
                                      <div class="col-auto">
                                        <span class="form-control-plaintext form-control-sm">
                                          <input
                                            type="checkbox"
                                            name="active"
                                            [ngModel]="carDetail.licenseAnnulation"
                                            onclick="return false;"
                                            [disabled]="true"
                                            />
                                          </span>
                                        </div>
                                      </div>
                                      <div class="form-group row">
                                        <label class="col-4 col-form-label-sm" translate
                                          >LEAD_LBL_DRIVER_NO_LICENSE_CONVICTION</label
                                          >
                                          <div class="col-auto">
                                            <span class="form-control-plaintext form-control-sm">
                                              <input
                                                type="checkbox"
                                                name="active"
                                                [ngModel]="carDetail.noLicenseConviction"
                                                onclick="return false;"
                                                [disabled]="true"
                                                />
                                              </span>
                                            </div>
                                          </div>
                                          <div class="form-group row">
                                            <label class="col-4 col-form-label-sm" translate
                                              >LEAD_LBL_DRIVER_LICENSE_CANCEL</label
                                              >
                                              <div class="col-auto">
                                                <span class="form-control-plaintext form-control-sm">
                                                  <input
                                                    type="checkbox"
                                                    name="active"
                                                    [ngModel]="carDetail.licenseCancel"
                                                    onclick="return false;"
                                                    [disabled]="true"
                                                    />
                                                  </span>
                                                </div>
                                              </div>
                                              @if (carDetail.licenseCancel) {
                                                <div class="form-group row">
                                                  <label class="col-4 col-form-label-sm" translate
                                                    >LEAD_LBL_DRIVER_LICENSE_CANCEL_MOTIVE</label
                                                    >
                                                    <div class="col-auto">
                                                      <span class="form-control-plaintext form-control-sm">
                                                        {{ carDetail.licenseCancelMotiveLoc }}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div class="form-group row">
                                                    <label class="col-4 col-form-label-sm" translate
                                                      >LEAD_LBL_DRIVER_LICENSE_CANCEL_DATE</label
                                                      >
                                                      <div class="col-auto">
                                                        <span class="form-control-plaintext form-control-sm">
                                                          {{ carDetail.licenseCancelDate | date : "dd/MM/yyyy" }}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  }
                                                </div>
                                                <div class="col-12 col-xl-6">
                                                  <div class="form-group row">
                                                    <label class="col-4 col-form-label-sm" translate
                                                      >LEAD_LBL_DRIVER_LICENSE_SUSPENSION</label
                                                      >
                                                      <div class="col-auto">
                                                        <span class="form-control-plaintext form-control-sm">
                                                          <input
                                                            type="checkbox"
                                                            name="active"
                                                            [ngModel]="carDetail.licenseSuspension"
                                                            onclick="return false;"
                                                            [disabled]="true"
                                                            />
                                                          </span>
                                                        </div>
                                                      </div>
                                                      @if (carDetail.licenseSuspension) {
                                                        <div class="form-group row">
                                                          <label class="col-4 col-form-label-sm" translate
                                                            >LEAD_LBL_DRIVER_LICENSE_SUSPENSION_MOTIVE</label
                                                            >
                                                            <div class="col-auto">
                                                              <span class="form-control-plaintext form-control-sm">
                                                                {{ carDetail.licenseSuspensionMotiveLoc }}
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div class="form-group row">
                                                            <label class="col-4 col-form-label-sm" translate
                                                              >LEAD_LBL_DRIVER_LICENSE_SUSPENSION_DATE</label
                                                              >
                                                              <div class="col-auto">
                                                                <span class="form-control-plaintext form-control-sm">
                                                                  {{ carDetail.licenseSuspensionDate | date : "dd/MM/yyyy" }}
                                                                </span>
                                                              </div>
                                                            </div>
                                                            <div class="form-group row">
                                                              <label class="col-4 col-form-label-sm" translate
                                                                >LEAD_LBL_DRIVER_LONGEST_SUSPENSION</label
                                                                >
                                                                <div class="col-auto">
                                                                  <span class="form-control-plaintext form-control-sm">
                                                                    {{ carDetail.longestSuspensionLoc }}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            }
                                                            <div class="form-group row">
                                                              <label class="col-4 col-form-label-sm" translate
                                                                >LEAD_LBL_DRIVER_ALCOHOL_DRUG_CONTROL</label
                                                                >
                                                                <div class="col-auto">
                                                                  <span class="form-control-plaintext form-control-sm">
                                                                    <input
                                                                      type="checkbox"
                                                                      name="active"
                                                                      [ngModel]="carDetail.alcoholDrugControl"
                                                                      onclick="return false;"
                                                                      [disabled]="true"
                                                                      />
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            @if (carDetail.carDisasters.length != 0) {
                                                              <div class="form-group-title my-1" translate="">
                                                                LEAD_FIELDSET_DISASTERS
                                                              </div>
                                                              <div class="d-flex flex-column h-100">
                                                                <table class="table table-striped border-bottom">
                                                                  <thead>
                                                                    <tr>
                                                                      <th>
                                                                        <a translate>LEAD_LBL_DISASTER_DATE</a>
                                                                      </th>
                                                                      <th>
                                                                        <a translate>LEAD_FIELDSET_REASON</a>
                                                                      </th>
                                                                      <th>
                                                                        <a translate>LEAD_FIELDSET_RESPONSIBLE</a>
                                                                      </th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    @for (disaster of carDetail.carDisasters; track disaster) {
                                                                      <tr
                                                                        class="row-action"
                                                                        >
                                                                        <td>{{ disaster.carDisasterDate | date : "dd/MM/yyyy" }}</td>
                                                                        <td>{{ disaster.carDisasterReason }}</td>
                                                                        <td>
                                                                          {{ disaster.carDisasterResponsiblePerson }}
                                                                        </td>
                                                                      </tr>
                                                                    }
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            }
                                                          </div>
                                                        </div>
                                                      }
